import { GrayColors } from "@smartsuite/types";
import styled from "styled-components";

export const MinWidthSelector = styled.div`
  width: 140px;
  .position-content {
    min-width: 150px;
  }

  .dropdown-panel {
    min-width: 150px;
  }

  .dropdown-panel-min-width {
    .position-content {
      min-width: 150px;
    }
    .dropdown-panel {
      min-width: 150px;
    }
  }
`;

export const Wrapper = styled.div<{
  marginBottom?: string;
  marginLeft?: string;
}>`
  margin-bottom: ${({ marginBottom }) =>
    marginBottom === undefined ? `0px` : `${marginBottom}`};
  margin-left: ${({ marginLeft }) =>
    marginLeft === undefined ? `0px` : `${marginLeft}`};
`;

export const RenderSelectedOption = styled.div`
  display: flex;
  align-items: center;
`;

export const RenderSelectedOptionTimezone = styled.span`
  padding-left: 10px;
  position: relative;
  display: flex;

  &:before {
    content: "";
    position: absolute;
    top: 7px;
    width: 2px;
    left: 5px;
    height: 2px;
    background-color: ${GrayColors["G-4"]};
    border-radius: 50%;
  }
`;
